import React from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import fiteAPI from '../fiterAPI';
import XPItem from './XPItem';

const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

class ProfessionalXPForm extends React.Component {
  constructor() {
    super();

    this.state = {
      initialMonth: '',
      finalMonth: '',
      initialYear: '',
      finalYear: '',
      companyName: '',
      jobPosition: '',
      isCurrent: false,
      professionalXP: []
    };

    this.handleCompanyName = this.handleTextChange('companyName').bind(this);
    this.handleJobPosition = this.handleTextChange('jobPosition').bind(this);
    this.handleInitialMonth = this.handleTextChange('initialMonth').bind(this);
    this.handleFinalMonth = this.handleTextChange('finalMonth').bind(this);
    this.handleInitialYear = this.handleTextChange('initialYear').bind(this);
    this.handleFinalYear = this.handleTextChange('finalYear').bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
  }

  componentDidMount() {
    const { professionalXP = [] } = this.props.userProfileData;

    this.setState({
      professionalXP
    });
  }

  async onSaveChanges() {
    this.props.turnOnLoading();
    const {
      initialMonth,
      finalMonth,
      initialYear,
      finalYear,
      companyName,
      jobPosition,
      isCurrent,
      professionalXP = []
    } = this.state;

    professionalXP.push({
      initialMonth,
      finalMonth,
      initialYear,
      finalYear,
      companyName,
      jobPosition,
      isCurrent
    });
    await fiteAPI.updateUser({ professionalXP });
    this.props.setCurrentUser();
  }

  handleTextChange = fieldName => event => {
    const { value } = event.target;
    this.setState({ [fieldName]: value });
  };

  render() {
    const { currentUser } = this.props;
    const {
      initialMonth,
      finalMonth,
      initialYear,
      finalYear,
      companyName,
      jobPosition,
      isCurrent,
      professionalXP
    } = this.state;

    return (
      <>
        {professionalXP.map(xp => (
          <XPItem {...xp} />
        ))}
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridCompanyName">
              <Form.Label style={{ fontWeight: 'bold' }}>Empresa</Form.Label>
              <Form.Control
                type="text"
                value={companyName || ''}
                onChange={this.handleCompanyName}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridJobPosition">
              <Form.Label style={{ fontWeight: 'bold' }}>Cargo</Form.Label>
              <Form.Control
                type="text"
                value={jobPosition || ''}
                onChange={this.handleJobPosition}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group
              as={Col}
              controlId="formGridInitialDate"
              md={12}
              style={{ marginBottom: 0 }}
            >
              <Form.Label style={{ fontWeight: 'bold' }}>
                Data de início
              </Form.Label>
            </Form.Group>

            <Form.Group as={Col} controlId="formGridInitialDate" md={4}>
              <Form.Control
                as="select"
                defaultValue={initialMonth || 'Mês'}
                onChange={this.handleInitialMonth}
              >
                <option>Mês</option>
                {MONTHS.map((month, index) => (
                  <option value={index + 1}>{month}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} controlId="formGridInitialDate" md={4}>
              <Form.Control
                as="select"
                defaultValue={initialYear || 'Ano'}
                onChange={this.handleInitialYear}
              >
                <option>Ano</option>
                {Array.from(Array(50)).map((_, i) => (
                  <option value={2020 - i}>{2020 - i}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group
              as={Col}
              controlId="formGridFnitialDate"
              md={12}
              style={{ marginBottom: 0 }}
            >
              <Form.Label style={{ fontWeight: 'bold' }}>
                Data de término
              </Form.Label>
              {/* <Form.Group controlId="formBasicCheckboxIsCurrent">
                <Form.Check
                  type="checkbox"
                  isChecked={isCurrent}
                  label="É meu trabalho atual"
                />
              </Form.Group> */}
            </Form.Group>

            <Form.Group as={Col} controlId="formGridFnitialDate" md={4}>
              <Form.Control
                as="select"
                defaultValue={finalMonth || 'Mês'}
                onChange={this.handleFinalMonth}
              >
                <option>Mês</option>
                {MONTHS.map((month, index) => (
                  <option value={index + 1}>{month}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} controlId="formGridFnitialDate" md={4}>
              <Form.Control
                as="select"
                defaultValue={finalYear || 'Ano'}
                onChange={this.handleFinalYear}
              >
                <option>Ano</option>
                {Array.from(Array(50)).map((_, i) => (
                  <option value={2020 - i}>{2020 - i}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col}>
              <Button onClick={this.onSaveChanges}>Adicionar</Button>
            </Form.Group>
          </Form.Row>
        </Form>
      </>
    );
  }
}

export default ProfessionalXPForm;
